import React from 'react';
import { IconProps } from './types';

const Crehanaicons32: React.FC<IconProps> = ({
  className,
  color = '#181B32',
  size = 32,
  ignoreColor,
}) => (
  <svg
    className={className}
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    width={1 * size}
    height={size}
    viewBox="0 0 32 32"
  >
    <path
      fill={!ignoreColor ? color : undefined}
      d="M28.801 18.351c1.298-1.417 2.097-3.299 2.097-5.371 0-4.4-3.568-7.965-7.966-7.965-2.602 0-4.905 1.252-6.359 3.181-1.454-1.929-3.757-3.181-6.359-3.181-4.4 0-7.965 3.565-7.965 7.965 0 2.088 0.81 3.983 2.125 5.403l-0.027 0.001 0.095 0.075c0.547 0.577 1.178 1.072 1.875 1.464l10.394 8.115 10.209-8.171c0.688-0.399 1.309-0.898 1.846-1.477l0.046-0.037-0.011-0.001z"
    />
  </svg>
);

export default Crehanaicons32;
